import { Ajuda } from '../../design/Ajuda';
import { useEffect, useState } from 'react';
import { diaCurto, lerMeuPainelDoGiro } from '../../giro';
import type { DiaDoMeuGiro } from '../../giro';

/**
 * COMO FOI MEU GIRO (dono, 26/09) — o dia do balconista com a NOTA e a mensagem: quantos
 * conferiu, quantos repôs, divergências, o que deixou de repor e o tempo. E os últimos 7 dias.
 * Só os números dele (o servidor nem manda os de ninguém).
 */

const tom = (n: number) =>
  n >= 9 ? 'gn-otimo' : n >= 7 ? 'gn-bom' : n >= 5 ? 'gn-medio' : 'gn-ruim';

export function ComoFoiMeuGiro() {
  const [d, setD] = useState<{ dias: readonly DiaDoMeuGiro[]; media: number | null } | null>(null);
  useEffect(() => {
    void lerMeuPainelDoGiro(7).then((r) => r.ok && setD(r.dados));
  }, []);
  const hoje = d?.dias[0];
  if (!d || !hoje) return null;
  return (
    <section className="gb-cartao gn" aria-label="Como foi meu Giro">
      <div className="gn-topo">
        <div>
          <b>
            Como foi meu Giro
            <Ajuda rotulo="a nota do Giro">
              A nota começa em 10. Perde pontos se o bloco não terminar, se o auditor achar
              diferença (divergência), se ficou item sem repor, se mais de um produto ficou como
              &quot;não localizei&quot; e se passou da meta de tempo.
            </Ajuda>
          </b>
          <em>{diaCurto(hoje.dia)}</em>
        </div>
        {hoje.emAndamento ? (
          <div className="gn-nota gn-andamento">
            <span>em andamento</span>
          </div>
        ) : (
          <div className={`gn-nota ${tom(hoje.nota)}`}>
            <strong>{hoje.nota}</strong>
            <span>/10</span>
          </div>
        )}
      </div>
      <p className={`gn-msg ${hoje.emAndamento ? 'gn-andamento' : tom(hoje.nota)}`}>
        {hoje.mensagem}
      </p>
      <div className="gn-grade">
        <div>
          <em>
            Conferiu
            <Ajuda rotulo="conferiu">Quantos produtos você contou na prateleira hoje.</Ajuda>
          </em>
          <b>{hoje.conferidos}</b>
        </div>
        <div>
          <em>
            Repôs
            <Ajuda rotulo="repôs">Quantas unidades você colocou na prateleira.</Ajuda>
          </em>
          <b>{hoje.repostosUnidades} un</b>
        </div>
        <div>
          <em>
            Divergências
            <Ajuda rotulo="divergências">
              Vezes em que o auditor achou diferente do que você informou. Cada uma tira 2 pontos.
            </Ajuda>
          </em>
          <b className={hoje.divergencias ? 'gn-alerta' : ''}>{hoje.divergencias}</b>
        </div>
        <div>
          <em>
            Deixou de repor
            <Ajuda rotulo="deixou de repor">
              Itens que o sistema mandou repor e ficaram sem repor. Cada um tira 1 ponto.
            </Ajuda>
          </em>
          <b className={hoje.deixouDeRepor ? 'gn-alerta' : ''}>{hoje.deixouDeRepor}</b>
        </div>
        <div>
          <em>
            Tempo
            <Ajuda rotulo="tempo">
              Minutos trabalhando no Giro (sem as pausas). Se tiver meta, aparece ao lado.
            </Ajuda>
          </em>
          <b
            className={
              hoje.metaMin && hoje.ativoMin && hoje.ativoMin > hoje.metaMin ? 'gn-alerta' : ''
            }
          >
            {hoje.ativoMin ?? '—'}
            {hoje.metaMin ? ` / ${String(hoje.metaMin)}` : ''} min
          </b>
        </div>
        <div>
          <em>
            Blocos
            <Ajuda rotulo="blocos">Blocos terminados de hoje / blocos que você recebeu.</Ajuda>
          </em>
          <b>
            {hoje.concluidos}/{hoje.blocos}
            {hoje.transferidos ? ` · ${String(hoje.transferidos)} passado` : ''}
          </b>
        </div>
      </div>
      {d.dias.filter((x) => !x.emAndamento).length > 0 && d.dias.length > 1 && (
        <>
          <em className="gn-sub">
            Últimos dias{d.media !== null ? ` · média ${d.media.toLocaleString('pt-BR')}` : ''}
          </em>
          <div className="gn-dias">
            {[...d.dias]
              .filter((x) => !x.emAndamento)
              .reverse()
              .map((x) => (
                <div key={x.dia} className={`gn-dia ${tom(x.nota)}`} title={x.mensagem}>
                  <b>{x.nota}</b>
                  <span>{diaCurto(x.dia)}</span>
                </div>
              ))}
          </div>
        </>
      )}
    </section>
  );
}
